<template>
    <div>
      <div>
        <div class="c-card-body">
          <datatable
            ref="datatable"
            module="commission-summary"
            :title="title"
            :url="url"
            :columns="columns"
            :disable-create="true"
            :disable-action="true"
            :filter="[{ column: 'commission_summary_id', value: id }]"

          >
            <template
              v-if="!loading"
              v-slot:action
            >
              
            </template>
            <template v-slot:[`item.amount`]="{ item }">
          <div>
            Rp {{ new Intl.NumberFormat("id-ID").format(item.amount) }}
          </div>
        </template>
            
          </datatable>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Datatable from "@/view/component/Datatable.vue";
  
  export default {
    data() {
      return {
        title: "User",
        url: "commission-detail/data?id=" + this.id,
        columns: [
          {
            value: "id"
          },
          {
            text: "Paket",
            value: "sales_item_name",
            sortable: true,
            searchable: true
          },
           {
            text: "Type",
            value: "type",
            sortable: true,
            searchable: true,
          },
          {
            text: "Jumlah",
            value: "amount",
            sortable: true,
            searchable: true,
          },
          {
            text: "Description",
            value: "description",
            sortable: true,
            searchable: true,
          },
          

        ],
        data: [],
        loading: true
      };
    },
    props: {
      id: String,
    },
    methods: {
      // onClickCreate() {
      //   this.$refs.formBooking.open(this.id);
      // },
      // onClickUpdate(item) {
      //   this.$refs.formBooking.open(this.id, item.id);
      // },
      // onClickDelete(item) {
      //   this.$refs.delete.open(item.id);
      // },
      formSuccess() {
        this.$refs.datatable.getData();
      },
      deleteSuccess() {
        this.$refs.datatable.getData();
      }
    },
    mounted() {
      this.$watch(
        () => {
          return this.$refs.datatable.items;
        },
        val => {
          this.data = val;
          this.loading = false;
        }
      );
    },
    components: {
      Datatable,
    }
  };
  </script>
  